





















import { Component, Provide, Watch, Vue } from 'vue-property-decorator';

@Component
export default class HomeStation extends Vue {
  @Provide() selectedStation: any = null; // selected Station
  get stations() {
    return this.$pdc.entities!.stations.storedEntity.list;
  }
  mounted() {
    this.updateStation();
  }

  @Watch('stations')
  onStationsChange() {
    this.updateStation();
  }

  updateStation() {
    const stations = this.stations.filter((x) => x.online);
    if (stations.length) {
      this.selectedStation = stations[0];
      this.$emit('selectedStation', this.selectedStation);
    } else {
      this.selectedStation = this.stations[0];
    }
  }
}
